import  * as memberNullPidAction from "@app/actions/myoffice/member/holding-tank.action"
import { Member } from "@app/models/myoffice/member/member.model";
import { ResultProc } from "@app/models/system/result-proc.model";
import { createReducer, on } from "@ngrx/store";
import * as memberNullPidSelector from '@selectors/myoffice/member/holding-tank.selector'

export const holdingTankFeatureKey = 'holdingTank';

export const initialHoldingTank: memberNullPidSelector.HoldingTankState = {
    memberNullPid: [] as Member[],
    total: {} as Number,
    result: {} as ResultProc
}

export const holdingTankReducer = createReducer(
    initialHoldingTank,
    on(memberNullPidAction.findListMemberNullPidSuccess, (state, {member}) => ({
        ...state, 
        memberNullPid: member
    })),
    on(memberNullPidAction.countListMemberNullPidSuccess,(state, {total}) => ({
        ...state,
        total,
    })),
    on(memberNullPidAction.savePidSuccess,(state, {result}) => {
        
        return ({
            ...state,
            result: result,
        })
    }),

)